import {
  ensurePortalEnvelope,
  serializePortalDraft,
  tryParsePortalDraft,
} from '../portal/portalDraftEnvelope';
import type { DraftNotebookKind } from './draftNotebookKind';

function stripHtml(s: string): string {
  const t = s.trim();
  if (!t) return '';
  if (typeof document === 'undefined') {
    return t
      .replace(/<[^>]+>/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
  }
  const d = document.createElement('div');
  d.innerHTML = t;
  return (d.textContent || '').replace(/\u00a0/g, ' ').trim();
}

/**
 * Replaces the article portal body with HTML returned from cluster draft generation.
 */
export function mergeClusterArticleHtmlIntoArticleDraft(
  draftSerialized: string,
  articleHtml: string,
  notebookId: string,
  draftTitle: string,
  draftKind: DraftNotebookKind
): string {
  const trimmed = articleHtml.trim();
  if (!trimmed) return draftSerialized;

  const parsed = tryParsePortalDraft(draftSerialized);
  if (parsed?.kind === 'article') {
    const plain = stripHtml(trimmed) || ' ';
    const nextPayload = {
      ...parsed.payload,
      content: plain,
      content_blocks: [{ type: 'paragraph', text: plain, html: trimmed }],
    };
    return serializePortalDraft({ schemaVersion: 1, kind: 'article', payload: nextPayload });
  }

  const env = ensurePortalEnvelope(draftSerialized, draftTitle, notebookId, draftKind);
  if (env.kind !== 'article') return draftSerialized;
  const plain = stripHtml(trimmed) || ' ';
  const nextPayload = {
    ...env.payload,
    content: plain,
    content_blocks: [{ type: 'paragraph', text: plain, html: trimmed }],
  };
  return serializePortalDraft({ schemaVersion: 1, kind: 'article', payload: nextPayload });
}
